export const API_URL = "https://api.fluid.fo";
export const CLOUDFLARE_TURNSTILE_SITEKEY = "0x4AAAAAAAL9sDhaBoP0ppfJ";
export const STORE_NAME = "Fluid";